module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_data02-0411ba1f1d286da6704bd83c35bdc934.png";